// @flow
import {Models, Factories} from '@wellstone-solutions/common';
import type {
  ApiSessionDocumentInputType,
  ApiSessionDocumentInputFactoryType,
  ApiSessionDocumentType,
  ApiSessionDocumentFactoryType,
  UISessionDocumentType,
  UISessionDocumentFactoryType,
} from './types';

const {MemberBasic} = Models;
const {createFactory} = Factories;

// camelCase per the V2 contract. Relations are bare UUIDs in both directions —
// member/staff are Member PKs and typeOfService a list of OrgSessionServiceType
// PKs. Bridge resolves those to nested UI objects (see transforms.toUI).
const ApiBaseFields = {
  id: null,
  changeReason: '',
  edited: null,
  status: 'draft',
  dateOfService: '',
  startTime: '',
  endTime: '',
  titleOrReason: '',
  sessionType: '',
  didMemberAttend: '',
  location: '',
  notes: '',
  nextSteps: '',
  isAllDay: false,
  submittedAt: null,
  completed: null,
  reverted: null,
  integrationErrors: [],
  integrationRelationship: null,
};

const UIBaseFields = {
  id: null,
  changeReason: '',
  edited: null,
  status: 'draft',
  dateOfService: '',
  startTime: '',
  endTime: '',
  titleOrReason: '',
  sessionType: '',
  didMemberAttend: '',
  location: '',
  notes: '',
  nextSteps: '',
  isAllDay: false,
  submittedAt: null,
  completed: null,
  typeOfService: [],
  reverted: null,
  integrationErrors: [],
  integrationRelationship: null,
};

// input/payloads — bare UUID relations
const defaultApiInputFields = {
  ...ApiBaseFields,
  member: '',
  staff: '',
  typeOfService: [],
};

// response — bare UUID relations, same as writes plus the read-only timestamps
const defaultApiFields = {
  ...ApiBaseFields,
  member: '',
  staff: '',
  created: '',
  modified: '',
  typeOfService: [],
};

const defaultUIFields = {
  ...UIBaseFields,
  member: MemberBasic.Factory(),
  staff: MemberBasic.Factory(),
  created: '',
  modified: '',
};

// used for tests - to mock a call to api endpoint
export const ApiInputFactory = (
  overrides: ApiSessionDocumentInputFactoryType,
): ApiSessionDocumentInputType =>
  createFactory(defaultApiInputFields, overrides);

// Response shapes
export const ApiFactory = (
  overrides: ApiSessionDocumentFactoryType,
): ApiSessionDocumentType => createFactory(defaultApiFields, overrides);

// makes UI Response shape
export const Factory = (
  overrides: UISessionDocumentFactoryType,
): UISessionDocumentType => createFactory(defaultUIFields, overrides);
